
var maxLineChartPlugin = {
    renderMaxText: function (ctx, text, x, y, wc, rh) {
        var midX = x + (wc / 2);
        var fontSize = 14;
        ctx.fillStyle = "#FFffff";
        ctx.textBaseline = "middle";
        ctx.font = "500 " + fontSize + "px Roboto";
        var m = ctx.measureText(text);

        while (m.width > wc) {
            fontSize -= 1;
            ctx.font = "500 " + fontSize + "px Roboto";
            m = ctx.measureText(text);
        }

        ctx.fillText(text, midX - (m.width / 2), rh / 2);
    },
    renderMaxLine: function (c) {
        const meta = c.getDatasetMeta(0);
        var xAxis = c.scales["x-axis-0"];
        var maxIdx = -1;
        var max = c.config.data.datasets[0].data.reduce(function (a, v, i) { return Math.max(a, v); });
        c.config.data.datasets[0].data.forEach(function (e, i) { maxIdx = e == max ? i : maxIdx; });

        var y = xAxis.top;
        var x = meta.data[maxIdx]._model.x;

        var ctx = c.chart.ctx;

        ctx.strokeStyle = "#FF6D6066";
        ctx.fillStyle = "#FF6D60";
        ctx.lineWidth = 2;
        ctx.setLineDash([5, 3]);

        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x, 0);
        ctx.stroke();

        var rX = x - 25;
        if (maxIdx == 0) rX = x;

        ctx.rect(rX, 0, 50, 25);
        ctx.fill();

        this.renderMaxText(ctx, max.toLocaleString(), rX + 5, 5, 40, 25);

    },
    afterDatasetsDraw: function (c) {
        this.renderMaxLine(c);
    }
};

$(function () {
    $(".widget-user-growth").each(function (idx, element) {
        var dataUrl = $(element).data("url");
        var $canvas = $(element).find("canvas");
        var $content = $(element).find(".cv-container");
        var $error = $(element).find(".user-growth-error");
        var canvas = $canvas.get(0);

        if (!canvas) return;

        /**
         * Processes the data retrieved from the server
         */
        var _processData = function (d) {
            if (!d || !d.length) {
                _showError("Invalid data received");
                return;
            }

            //if (d.length == 0) {
            //    $error.hide();
            //    $spinner.hide();
            //    $canvas.hide();
            //    $empty.show();
            //    return;
            //}

            var chartLabels = [];
            var values = [];

            for (var i = 0; i < d.length; i++) {
                chartLabels.push(d[i].DateString);
                values.push(d[i].Users);
            }

            //$spinner.hide();
            $content.show();

            var context = canvas.getContext('2d');

            var gradient = context.createLinearGradient(0, 0, 0, 160);
            gradient.addColorStop(0, 'rgba(54, 162, 235, .2)');
            gradient.addColorStop(1, 'rgba(54, 162, 235, 0)');

            var chart = new Chart(context, {
                type: 'line',
                data: {
                    labels: chartLabels,
                    datasets: [{
                        label: "User Growth",
                        cubicInterpolationMode: "default",
                        data: values,
                        pointRadius: 0,
                        fill: true,
                        lineTension: 0,
                        backgroundColor: gradient,
                        borderColor: 'rgba(54, 162, 235, .8)',
                        borderWidth: 2
                    }]
                },
                options: {
                    maintainAspectRatio: false,
                    legend: {display: false},
                    scales: {
                        yAxes: [{
                            display: true,
                            ticks: {
                                display: true, beginAtZero: false, maxTicksLimit: 4,
                                callback: function (value, index, values) {
                                    return value.toLocaleString();
                                }
                            },
                            gridLines: { display: true, drawBorder: false, color: 'rgba(0,0,0,0.05)' }
                        }],
                        xAxes: [{
                            display: true,
                            ticks: { display: true },
                            gridLines: { display: false, drawBorder: true }
                        }]
                    }
                },
                plugins: [maxLineChartPlugin]
            });
        }

        /**
         * Displays an error message
         */
        var _showError = function (err) {
            $content.hide();
            //$spinner.hide();

            if (err) {
                $error.find("p").html(err);
            }

            $error.show();
        };

        /**
         * Fetches the chart data from the data url
         */
        var _fetchData = function () {
            $.ajax({
                url: dataUrl,
                method: 'GET',
                dataType: 'json',
                success: function (d) {
                    _processData(d);
                },
                error: function (x, s, e) {
                    _showError();
                }
            });
        }

        _fetchData();
    });
});